import { Link, useNavigate } from 'react-router-dom';
import { useAuth } from '../lib/auth';
import { ThemeToggle } from './ThemeToggle';
import { NotificationsBell } from './NotificationsBell';

/**
 * Slim brand header for the authed pages (Dashboard / PumpDetail /
 * Profile). Wordmark on the left, profile + sign-out on the right.
 *
 * Mobile-friendly: collapses the user-name to just initials below
 * Bootstrap's `sm` breakpoint.
 */
export function AppHeader() {
  const { user, signOut } = useAuth();
  const navigate = useNavigate();

  const display =
    user?.displayName || user?.givenName || user?.email || 'Profile';
  const initials = (display.match(/\b\w/g) || []).slice(0, 2).join('').toUpperCase();

  function onSignOut() {
    signOut();
    navigate('/login', { replace: true });
  }

  return (
    <header
      style={{
        background: 'var(--aqua-surface)',
        borderBottom: '1px solid var(--aqua-border)',
        height: 'var(--aqua-header-h)',
      }}
    >
      <div className="container h-100 d-flex align-items-center justify-content-between">
        <Link
          to="/dashboard"
          className="text-decoration-none d-flex align-items-center gap-2"
          style={{ color: 'var(--aqua-text-strong)' }}
        >
          <h1 className="h4 mb-0 fw-bold">AquaStar</h1>
        </Link>

        <div className="d-flex align-items-center gap-2">
          <Link
            to="/support"
            className="btn btn-sm btn-outline-secondary d-none d-sm-inline-block"
            title="Report a problem or track your issues"
          >
            Support
          </Link>
          <ThemeToggle />
          <NotificationsBell />
          <Link
            to="/profile"
            className="btn btn-sm d-flex align-items-center gap-2"
            style={{
              borderColor: 'var(--aqua-border)',
              color: 'var(--aqua-text)',
              background: 'var(--aqua-surface-muted)',
            }}
            title={display}
          >
            {user?.image ? (
              <img
                src={user.image}
                alt=""
                className="rounded-circle"
                style={{ width: 24, height: 24, objectFit: 'cover' }}
              />
            ) : (
              <span
                className="rounded-circle d-inline-flex align-items-center justify-content-center"
                style={{
                  width: 24,
                  height: 24,
                  background: 'var(--aqua-primary)',
                  color: '#fff',
                  fontSize: '0.7rem',
                  fontWeight: 600,
                }}
              >
                {initials || 'A'}
              </span>
            )}
            <span className="d-none d-sm-inline">{display}</span>
          </Link>
          <button
            type="button"
            className="btn btn-sm btn-outline-secondary"
            onClick={onSignOut}
          >
            Sign out
          </button>
        </div>
      </div>
    </header>
  );
}
